import { useAuth } from '@/hooks/useAuth'
import AdminSidebar from '@/components/AdminSidebar'

interface AdminLayoutProps {
  children: React.ReactNode
}

function AdminLayout({ children }: AdminLayoutProps) {
  const { logout } = useAuth()

  return (
    <div className="flex h-screen bg-background">
      <AdminSidebar onLogout={logout} />
      <div className="flex-1 flex flex-col">
        <main className="flex-1 overflow-y-auto p-6">{children}</main>
      </div>
    </div>
  )
}

export default AdminLayout